import _ from 'lodash'
import type { BaseDataItem, DataMapName } from '@wix/thunderbolt-becky-types'
import type { IDocumentDataStore } from './DocumentDataStore'
import { DocumentDataStore } from './DocumentDataStore'

interface IDataStore {
	updateData: (type: DataMapName, id: string, dataItem: BaseDataItem | undefined) => BaseDataItem | undefined
	getData: <T extends BaseDataItem = BaseDataItem>(type: DataMapName, id: string) => T | undefined
}

export class DataStore implements IDataStore {
	private readonly documentDataStore: IDocumentDataStore = new DocumentDataStore()
	private readonly rawModel: Record<string, any> = {}

	updateData(mapName: string, id: string, dataItem: BaseDataItem | undefined) {
		if (mapName === 'document_data') {
			return this.documentDataStore.updateData(id, dataItem)
		}
		_.set(this.rawModel, [mapName, id], dataItem)
		return dataItem
	}

	getData<T extends BaseDataItem = BaseDataItem>(mapName: string, id: string): T | undefined {
		if (mapName === 'document_data') {
			return this.documentDataStore.getData<T>(id)
		}
		return _.get(this.rawModel, [mapName, id]) as T
	}
}
